import { useEffect, useState } from "react";

import { convertNumberToCurrencyString } from "@usas/ui-web/utils/CurrencyUtils";

const useRefundToolFormGrid = (transactionObj, onSubmitFormCallback) => {
  const [formGridState, setFormGridState] = useState([]);
  const [canSubmitState, setCanSubmitState] = useState(false);

  const onUpdateAllGridItems = (isSelected) => {
    const newFormGridState = JSON.parse(JSON.stringify(formGridState));

    for (let i = 0; i < newFormGridState.length; i++) {
      if (newFormGridState[i].isRefunded === false && newFormGridState[i].canBeRefunded === true) {
        newFormGridState[i].isSelected = isSelected;
      }
    }

    setFormGridState(newFormGridState);
    setCanSubmitState(getCanSubmit(newFormGridState));
  };

  const onUpdateIsSelected = (id) => {
    const newFormGridState = JSON.parse(JSON.stringify(formGridState));

    for (let i = 0; i < newFormGridState.length; i++) {
      if (newFormGridState[i].id === id && newFormGridState[i].isRefunded === false && newFormGridState[i].canBeRefunded === true) {
        newFormGridState[i].isSelected = !newFormGridState[i].isSelected;
        break;
      }
    }

    setFormGridState(newFormGridState);
    setCanSubmitState(getCanSubmit(newFormGridState));
  };

  const onSubmitRefundClicked = (e) => {
    if (e) {
      e.preventDefault();

      const transactionItems = transactionObj.transactions || [];
      const itemsToRefund = [];

      for (const gridItem of formGridState) {
        if (gridItem.isSelected === true && gridItem.isRefunded === false && gridItem.canBeRefunded === true) {
          let targetItem = null;

          if (gridItem.memberRegistrationId) {
            targetItem = transactionItems.find((x) => x.memberRegistrationId === gridItem.memberRegistrationId);
          } else if (gridItem.transactionDetailId) {
            targetItem = transactionItems.find((x) => x.transactionDetailId === gridItem.transactionDetailId);
          }

          if (targetItem) {
            itemsToRefund.push(targetItem);
          }
        }
      }

      if (itemsToRefund.length > 0) {
        onSubmitFormCallback({ itemsToRefund });
      }
    }
  };

  useEffect(() => {
    if (Array.isArray(transactionObj.transactions)) {
      const formGridData = [];

      for (const transaction of transactionObj.transactions) {
        if (transaction) {
          formGridData.push({
            id: formGridData.length + 1,
            transactionDetailId: transaction.transactionDetailId,
            memberRegistrationId: transaction.memberRegistrationId,
            itemName: transaction.descriptionDetail || '',
            isFromPriorSeason: transaction.isFromPriorSeason === true,
            amount: convertNumberToCurrencyString(transaction.amount / 100),
            isRefunded: transaction.isRefunded === true,
            canBeRefunded: transaction.canBeRefunded === true,
            isSelected: transaction.isRefunded === true || transaction.canBeRefunded !== true ? null : false
          });
        }
      }

      setFormGridState(formGridData);
    }
  }, [transactionObj]);

  function getCanSubmit(newFormGridState) {
    for (const transaction of newFormGridState) {
      if (transaction.isSelected === true) {
        return true;
      }
    }

    return false;
  }

  return {
    formGridState,
    canSubmit: canSubmitState === true,
    onUpdateAllGridItems,
    onUpdateIsSelected,
    onSubmitRefundClicked
  };
};

export default useRefundToolFormGrid;